var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 12.7857H3.24944C2.82087 12.7857 2.49944 12.4643 2.49944 12.0357C2.49944 11.6071 2.82087 11.2857 3.24944 11.2857H8.82087V16.75C8.82087 17.1786 8.49944 17.5 8.07087 17.5C7.6423 17.5 7.32087 17.1786 7.32087 16.75V13.8571L2.3923 18.7857C2.17801 18.8929 1.96373 19 1.74944 19C1.53516 19 1.32087 18.8929 1.21373 18.7857C0.892299 18.4643 0.892299 17.9286 1.21373 17.6071L6.03516 12.7857Z",
    fill: "#204354"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0351 2.39284C12.4637 2.39284 12.7851 2.71427 12.7851 3.14284L12.7851 6.0357L17.6066 1.21427C17.928 0.892839 18.4637 0.892839 18.7851 1.21427C19.1066 1.5357 19.1066 2.07141 18.7851 2.39284L13.9637 7.21427L16.8566 7.21427C17.2851 7.21427 17.6066 7.5357 17.6066 7.96427C17.6066 8.39284 17.2851 8.71427 16.8566 8.71427L11.178 8.71427L11.178 3.14284C11.178 2.71427 11.6066 2.39284 12.0351 2.39284Z",
    fill: "#204354"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.767307c0df2465409f80e5547168bb69.svg";
export { ForwardRef as ReactComponent };